import { gql } from "@apollo/client";

export const ME = gql`
	query MeHeader {
		me {
			id
			name
			avatar
		}
	}
`;

export const HASCLASS = gql`
	query HasClass($classId: ID!) {
		class(id: $classId) {
			id
		}
	}
`;

export const USER_CHECKOUTS = gql`
	query userCheckoutsHeader($offset: Int, $limit: Int) {
		userCheckouts(offset: $offset, limit: $limit) {
			count
			checkouts {
				id
				isActive
				order {
					id
					status
					boletoUrl
					boletoExpirationDate
					enrollmentStatus
				}
				classPrice {
					id
					originalPrice
					discount
					finalPrice
				}
				class {
					id
					name
					shift
					type
					price
					originalPrice
					discount
					availableSpots
					isMatriculae
					period {
						id
						semester
					}
					courseInstitution {
						id
						graduationType
						duration
						durationType
					}
					campus {
						id
						addressCity
						addressState
						name
					}
					course {
						id
						name
						level
						slug
					}
					institution {
						id
						logo
						name
						slug
						isMatriculaeInstitution
					}
				}
			}
		}
	}
`;

export const FETCH_FULL_CITIES = gql`
	query fullCities($institutionId: ID) {
		fullCities(institutionId: $institutionId) {
			selectedCity {
				id
				city
				stateUF
				cityUF
			}
			cities {
				id
				city
				stateUF
				cityUF
			}
		}
	}
`;
